<template>
  <div class="ndwi">
    <!-- <p>{{$ml.get('Ndwi')}}</p> -->
    <br />
    <br />
    <satellite-selector v-model="satellite" :items="satellites" />
    <br />
    <br />
    <model-selector v-model="model" :items="models" />
    <br />
    <br />
    <!-- <date-selector />
    <br />
    <br /> -->
  </div>
</template>

<script>
import SatelliteSelector from '@/components/satellite/SatelliteSelector'
import ModelSelector from '@/components/satellite/ModelSelector'
// import DateSelector from '@/components/satellite/DateSelector'

export default {
  data() {
    return {
      satellite : 0,
      satellites: [
        {
          id: 0,
          value: 'sentinel-s2-l1c',
          name: 'sentinel-s2-l1c',
        },
        {
          id: 1,
          value: 'landsat-pds',
          name: 'landsat-pds',
        },
        {
          id: 2,
          value: 'sentinel-s2-l2a',
          name: 'sentinel-s2-l2a',
        },
      ],
      model: 0,
      models: [
        {
          id: 0,
          value: 'ndvi',
          name: 'ndvi',
        },
        {
          id: 1,
          value: 'msavi2',
          name: 'msavi2',
        },
        {
          id: 2,
          value: 'rgb',
          name: 'rgb',
        },
      ],

    }
  },
  created() {
    this.$store.dispatch('satellite/setDates');
    this.$store.dispatch('satellite/selectModel', this.model);
    this.$store.dispatch('satellite/selectSatellite', this.satellite);
  },
  components: {
    SatelliteSelector,
    ModelSelector,
    // DateSelector,
  }
}
</script>

<style lang="scss" scoped>
</style>
